import React from "react";
import { twMerge } from "tailwind-merge";
interface CustomRadioGroupButtonProp {
  active: boolean;
  onClick: () => void;
  className?: string;
}
const CustomRadioGroupButton = ({
  active,
  onClick,
  className,
}: CustomRadioGroupButtonProp) => {
  return (
    <div
      onClick={onClick}
      className={twMerge(
        "border-primary-dark flex h-[20px] w-[20px] items-center justify-center rounded-[5px] bg-white shadow-[0px_2px_4px_#12291F52]",
        active ? `bg-[#F26527] ${className}` : className,
      )}
    >
      {active && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.1"
          height="13.497"
          viewBox="0 0 18.1 13.497"
          className="scale-75"
        >
          <path
            id="Icon_awesome-check"
            data-name="Icon awesome-check"
            d="M6.148,17.809.265,11.927a.905.905,0,0,1,0-1.28l1.28-1.28a.9.9,0,0,1,1.28,0L6.787,13.33l8.488-8.488a.905.905,0,0,1,1.28,0l1.28,1.28a.905.905,0,0,1,0,1.28L7.427,17.809A.9.9,0,0,1,6.148,17.809Z"
            transform="translate(0 -4.577)"
            fill="#FFF"
          />
        </svg>
      )}
    </div>
  );
};
export default CustomRadioGroupButton;
